
import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const OrderPolicyValuesComponent = ({
  selectedOrderPolicyValues,
  onFormOrderPolicyItemChange,
  selectedOrderPolicys,
  categories,
  products
}: any) => {

  return(
  <>
    {_.map(
      selectedOrderPolicyValues,
      (selectedOrderPolicyValue: any, index: any) => (
        <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4 border p-4">
          
          {selectedOrderPolicys.OrderTypeId === 3 &&
           <InputContainer
               labelField="Name"
               list={products}
             label="Name"
               onValueChange={(event: any) => {
                 onFormOrderPolicyItemChange({
                  value: event.target.value,
                   field: 'EntityId',
                   idx: index
                 });
               }}
               type="select"
               value={selectedOrderPolicyValue?.EntityId}
               valueField="Id"
           />}
            {selectedOrderPolicys.OrderTypeId === 4 &&
              <InputContainer
                  labelField="CategoryName"
                  list={categories}
                  label="Name"
                  onValueChange={(event: any) => {
                    onFormOrderPolicyItemChange({
                      value: event.target.value,
                      field: 'EntityId',
                      idx: index
                    });
                  }}
                  optionName='Choose Category'
                  type="select"
                  value={selectedOrderPolicyValue?.EntityId}
                  valueField="Id"
              />}
            {/* {selectedOrderPolicys.OrderTypeId === 112 &&
              <InputContainer
                  labelField="Title"
                  list={topics}
                  onValueChange={(event: any) => {
                    onFormOrderPolicyItemChange({
                      value: event.target.value,
                      field: 'EntityId',
                      idx: index
                    });
                  }}
                  optionName='Choose Topic'
                  type="select"
                  value={selectedOrderPolicyValue?.EntityId}
                  valueField="Id"
              />} */}
                 {/* {selectedOrderPolicys.OrderTypeId === 113 &&
              <InputContainer
                  labelField="Title"
                  list={courses}
                  onValueChange={(event: any) => {
                    onFormOrderPolicyItemChange({
                      value: event.target.value,
                      field: 'EntityId',
                      idx: index
                    });
                  }}
                  optionName='Choose Course'
                  type="select"
                  value={selectedOrderPolicyValue?.EntityId}
                  valueField="Id"
              />}
               {selectedOrderPolicys.OrderTypeId === 115 &&
              <InputContainer
                  labelField="Title"
                  list={learningPaths}
                  onValueChange={(event: any) => {
                    onFormOrderPolicyItemChange({
                      value: event.target.value,
                      field: 'EntityId',
                      idx: index
                    });
                  }}
                  optionName='Choose LearningPath'
                  type="select"
                  value={selectedOrderPolicyValue?.EntityId}
                  valueField="Id"
              />}
              {selectedOrderPolicys.OrderTypeId === 116 &&
              <InputContainer
                  labelField="Title"
                  list={collections}
                  onValueChange={(event: any, newValue: any) => {
                    onFormOrderPolicyItemChange({
                      value: event.target.value,
                      field: 'EntityId',
                      idx: index
                    });
                  }}
                  optionName='Choose Collection'
                  type="select"
                  value={selectedOrderPolicyValue?.EntityId}
                  valueField="Id"
              />} */}
                    
                    

                    <InputContainer
                        labelField="ReturnPeriod"
                        label="Return Period"
                        onValueChange={(event: any, newValue: any) => {
                          onFormOrderPolicyItemChange({
                            value: event.target.value,
                            field: 'ReturnPeriod',
                            idx: index
                          });
                        }}
                        type="number"
                        value={selectedOrderPolicyValue?.ReturnPeriod}
                    />
        
        </div>
      ),
    )}
  </>
)}
export default OrderPolicyValuesComponent;
